import { render, staticRenderFns } from "./roleStaff.vue?vue&type=template&id=75e48890&scoped=true"
import script from "./roleStaff.vue?vue&type=script&lang=js"
export * from "./roleStaff.vue?vue&type=script&lang=js"
import style0 from "./roleStaff.vue?vue&type=style&index=0&id=75e48890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e48890",
  null
  
)

export default component.exports